import React, { Component } from "react";

import UserImage from "../../user_image";

import Countdown from "react-countdown-now";
import Moment from "react-moment";
import "moment-timezone";

import ModalGiveAway from "./modal/modal_giveaway";

import { Link } from "react-router-dom";

import ListWinner from "./winner/list_winner";

import SharingInviteView from "../../share/sharing_invite_view";

import YAYFlag from "../../../design/img/yaystack-icon-orange-white.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTicketAlt } from "@fortawesome/free-solid-svg-icons";

// Localization
import LocalizedStrings from "react-localization";
import en from "../../../localization/localization-en.json";
let strings = new LocalizedStrings({ en });

class ListUser extends Component {
  state = { openMedia: false, openGift: false };
  render() {
    var className = "list_user give_away_min_folower";
    // if (this.props.list.give_away) {
    //   className +=
    //     this.props.list.give_away.min_followers > 0
    //       ? " give_away_min_folower"
    //       : "";
    // }
    return (
      <div className={className}>
        {this.renderView()}
        {this.renderLetsGoButton()}
      </div>
    );
  }

  renderView() {
    if (this.props.list.give_away) {
      return this.renderGiveAway();
    }
    if (this.props.list.last_give_aways) {
      if (this.props.list.last_give_aways[0].winner) {
        return (
          <div>
            <div className="row max_width_500">
              <div
                className="width_image_question give_away_user"
                onClick={this.goToUserPage}
                style={{
                  marginTop: "4px",
                  marginLeft: "4px",
                  maxWidth: "60px",
                  width: "60px"
                }}
              >
                <UserImage
                  user={this.props.list.user}
                  bottomImage={false}
                  link={false}
                />
              </div>

              <div
                className="width_text_question btn cursor_btn align_element "
                onClick={this.goToUserPage}
              >
                <div className="cursor_btn width_100">
                  <label
                    className="cursor_btn user_name"
                    style={{
                      marginTop: "2px",
                      fontSize: "14px",
                      fontFamily: "DIN Pro Black",
                      textTransform: "uppercase"
                    }}
                  >
                    {this.props.list.user.first_name}{" "}
                    {this.props.list.user.last_name}
                  </label>
                  <label
                    className="cursor_btn user_username yaystack_color"
                    style={{
                      marginTop: "-5px",
                      fontSize: "12px"
                    }}
                  >
                    {this.props.list.user.username}
                  </label>
                </div>
              </div>
              <div
                className="width_image_question give_away_user"
                style={{
                  marginTop: "2.5px",
                  marginRight: "2.5px",
                  maxWidth: "60px",
                  width: "60px"
                }}
              >
                <div
                  className="center "
                  onClick={this.clickGift}
                  style={{ cursor: "pointer" }}
                >
                  <div className="user_img" style={{ cursor: "unset" }}>
                    <div className="user_img_div color_closed_friends" />
                    <img
                      className="no_border"
                      src={this.props.list.last_give_aways[0].image_url_medium}
                      alt=""
                    />
                  </div>
                </div>
                <ModalGiveAway
                  open={this.state.openGift}
                  handleCloseView={this.closeGift}
                  give_away={this.props.list.last_give_aways[0]}
                />
                {/* </Link> */}
              </div>
            </div>

            <label className="name">Winner!</label>
            <div className="image-profile center">
              <img
                className=""
                src={YAYFlag}
                alt=""
                style={{
                  width: "25%",
                  position: "absolute",
                  top: "80px",
                  left: "6.5px",
                  zIndex: "99999"
                }}
              />
              <UserImage
                user={this.props.list.last_give_aways[0].winner}
                link={this.props.link}
              />
            </div>
            <label className="name">
              {this.props.list.last_give_aways[0].winner.first_name}{" "}
              {this.props.list.last_give_aways[0].winner.last_name}
            </label>
            <label className="username">
              {this.props.list.last_give_aways[0].winner.username}
            </label>
            <label className="like_to_know ">{this.props.list.title}</label>
            {this.renderQuestionsNbr()}
          </div>
        );
      }
    }
    return (
      <div>
        <label className="number_questions">
          {this.props.questionNumber} {strings.questions}
        </label>
        <div className="image-profile center pt-2">
          <UserImage user={this.props.list.user} link={this.props.link} />
        </div>
        <label className="name">
          {this.props.list.user.first_name} {this.props.list.user.last_name}
        </label>
        <label className="username">{this.props.list.user.username}</label>
        <label className="like_to_know">{this.props.list.title}</label>
      </div>
    );
  }

  renderGiveAway() {
    return (
      <div>
        <div className="row max_width_500">
          <div
            className="width_image_question give_away_user"
            onClick={this.goToUserPage}
            style={{
              marginTop: "4px",
              marginLeft: "4px",
              maxWidth: "60px",
              width: "60px"
            }}
          >
            <UserImage
              user={this.props.list.user}
              bottomImage={false}
              link={false}
            />
          </div>

          <div
            className="width_text_question btn cursor_btn align_element "
            onClick={this.goToUserPage}
          >
            <div className="cursor_btn width_100">
              <label
                className="cursor_btn user_name"
                style={{
                  marginTop: "2px",
                  fontSize: "14px",
                  fontFamily: "DIN Pro Black",
                  textTransform: "uppercase"
                }}
              >
                {this.props.list.user.first_name}{" "}
                {this.props.list.user.last_name}
              </label>
              <label
                className="cursor_btn user_username yaystack_color_important"
                style={{
                  marginTop: "-5px",
                  fontSize: "12px"
                }}
              >
                {this.props.list.user.username}
              </label>
            </div>
          </div>
          {this.renderShareButton()}
        </div>

        <div>{this.renderUrl()}</div>
        {this.renderImage()}
        <label className="name">{this.props.list.give_away.item}</label>
        <label className="like_to_know">
          {this.props.list.give_away.description}
        </label>

        <div
          style={{ fontSize: "30px", fontFamily: "DIN Pro Light" }}
          className="yaystack_color"
        >
          <div
            style={{
              fontSize: "12px",
              fontFamily: "DIN Pro Bold",
              color: "black",
              marginBottom: "-5px"
            }}
          >
            <Moment
              date={this.props.list.give_away.end_at}
              format="MMMM Do, h:mmA [ET]"
              tz="America/New_York"
            />
          </div>
          <Countdown
            date={this.props.list.give_away.end_at}
            onComplete={this.countdownCompleted}
          />
        </div>
      </div>
    );
  }

  renderImage() {
    if (this.props.list.give_away.image_url_medium) {
      return (
        <React.Fragment>
          <div
            className="image-profile center pt-2"
            onClick={this.clickMedia}
            style={{ cursor: "pointer" }}
          >
            <div className="user_img" style={{ cursor: "unset" }}>
              <div className="user_img_div color_not_friends" />
              <img
                className="no_border"
                src={this.props.list.give_away.image_url_medium}
                alt=""
              />
            </div>
          </div>
          <ModalGiveAway
            open={this.state.openMedia}
            handleCloseView={this.closeMedia}
            give_away={this.props.list.give_away}
          />
        </React.Fragment>
      );
    } else if (this.props.list.give_away.video_url_original) {
      return (
        <React.Fragment>
          <div
            className="image-profile center pt-2"
            onClick={this.clickMedia}
            style={{ cursor: "pointer" }}
          >
            <div className="user_img" style={{ cursor: "unset" }}>
              <div className="user_img_div color_closed_friends" />
              <img
                className="no_border"
                src={this.props.list.give_away.video_url_image}
                alt=""
              />
            </div>
          </div>
          <ModalGiveAway
            open={this.state.openMedia}
            handleCloseView={this.closeMedia}
            give_away={this.props.list.give_away}
          />
        </React.Fragment>
      );
    }
  }

  renderQuestionsNbr() {
    if (this.props.feed === true) return <div className="pb-2" />;
    return (
      <label className="number_questions pb-2">
        {this.props.questionNumber} {strings.questions}
      </label>
    );
  }

  renderLetsGoButton() {
    if (this.props.feed === true) {
      if (this.props.list.last_give_aways) {
        return <div />;
      }
      var classBtn = "btn btn_primary btn_yaystack btn_next";
      // if (this.props.list.give_away) {
      //   classBtn += this.props.list.give_away.min_followers > 0 ? "" : "";
      // }
      if (this.props.list.give_away) {
        if (this.props.list.give_away.min_followers) {
          if (
            this.props.list.give_away.user_followers <
            this.props.list.give_away.min_followers
          ) {
            return (
              <div className="">
                <button
                  className={classBtn}
                  style={{
                    minWidth: "45%",
                    borderRadius: "10px",
                    marginBottom: "8px"
                  }}
                  onClick={this.handleInviteFriendButton}
                >
                  INVITE FRIENDS
                </button>
                {this.renderGiveAwayNbr()}
              </div>
            );
          }
        }
      }

      return (
        <div className="">
          <button
            className={classBtn}
            style={{
              width: "45%",
              borderRadius: "10px",
              marginBottom: "8px"
            }}
          >
            LET'S GO
          </button>
          {this.renderGiveAwayNbr()}
        </div>
      );
    }
  }

  renderGiveAwayNbr() {
    if (this.props.feed === true && this.props.list.give_away) {
      if (this.props.list.give_away.min_followers > 0) {
        const textMinumumFollowers =
          this.props.list.give_away.min_followers === 1
            ? `You need ${
                this.props.list.give_away.min_followers
              } follower to enter to win`
            : `You need ${
                this.props.list.give_away.min_followers
              } followers to enter to win`;

        return (
          <React.Fragment>
            <label
              className="btn_skip"
              style={{
                fontSize: "12px",
                textTransform: "capitalize",
                paddingBottom: "2px",
                paddingBottom: "8px",
                marginBottom: "0px",
                fontFamily: "DIN Pro Bold"
              }}
              onClick={this.handleInviteFriendButton}
            >
              {textMinumumFollowers}
            </label>
          </React.Fragment>
        );
      }
    }
    return <div className="pb-2" />;
  }

  renderShareButton() {
    if (this.props.user)
      return (
        <div
          className="width_image_question give_away_user"
          style={{
            marginTop: "12px",
            marginRight: "12px",
            maxWidth: "60px",
            width: "60px",
            alignItems: "start"
          }}
        >
          <div
            className="center "
            style={{ cursor: "pointer" }}
            onClick={this.handleInviteFriendButton}
          >
            {/* <div className="user_img" style={{ cursor: "unset" }}> */}
            {/* <ion-icon
              class="yaystack_icon_navBar ion-icon"
              name="ios-share-alt"
              style={{ fontSize: "30px" }}
            /> */}
            <FontAwesomeIcon
              className="yaystack_icon_navBar yaystack_color_important"
              icon={faTicketAlt}
              style={{ fontSize: "38px" }}
            />
            <div style={{ fontSize: "8px" }}>Add Entries</div>
            {/* <img
            className="no_border"
            src={this.props.list.last_give_aways[0].image_url_medium}
            alt=""
          /> */}
            {/* </div> */}
          </div>
          {this.renderShareView()}
        </div>
      );
  }

  renderShareView() {
    if (this.state.showSharingView) {
      return (
        <SharingInviteView
          handlerInviteFriend={this.handlerInviteFriend}
          username={this.props.user.username}
        />
      );
    }
  }

  handleInviteFriendButton = event => {
    event.preventDefault();
    const showSharingView = !this.state.showSharingView;
    this.setState({ showSharingView });
  };

  handlerInviteFriend = e => {
    const showSharingView = !this.state.showSharingView;
    this.setState({ showSharingView });
  };

  renderUrl() {
    // if (this.props.list.give_away.url != "") {
    //   return (
    //     <React.Fragment>
    //       <label
    //         className="number_questions pb-2"
    //         style={{
    //           display: "inline-block",
    //           marginLeft: "10px",
    //           marginRight: "10px",
    //           width: "calc(50% - 21px)",
    //           textAlign: "right"
    //         }}
    //       >
    //         Answer {this.props.questionNumber} {strings.questions} To
    //       </label>
    //       {/* <div
    //         style={{
    //           display: "inline-block",
    //           width: "1px",
    //           height: "10px",
    //           backgroundColor: "red"
    //         }}
    //       />
    //       <label
    //         className="number_questions pb-2"
    //         style={{
    //           display: "inline-block",
    //           marginLeft: "10px",
    //           marginRight: "10px",
    //           width: "calc(50% - 21px)",
    //           textAlign: "left"
    //         }}
    //         onClick={this.visitSite}
    //       >
    //         {strings.visit_site}
    //       </label> */}
    //     </React.Fragment>
    //   );
    // }
    return (
      <div>
        <label
          className="number_questions"
          style={{
            display: "block",
            marginBottom: "0px"
          }}
        >
          Answer {this.props.questionNumber} {strings.questions} to
        </label>
        <label
          className="name"
          style={{ paddingBottom: "5px", lineHeight: "30px" }}
        >
          ENTER TO WIN
        </label>
      </div>
    );
  }

  clickMedia = event => {
    event.preventDefault();
    const openMedia = true;
    this.setState({ openMedia });
  };

  closeMedia = e => {
    const openMedia = false;
    this.setState({ openMedia });
  };

  clickGift = event => {
    event.preventDefault();
    const openGift = true;
    this.setState({ openGift });
  };

  closeGift = event => {
    const openGift = false;
    this.setState({ openGift });
  };

  visitSite = event => {
    event.preventDefault();
    var win = window.open(this.props.list.give_away.url, "_blank");
    win.focus();
  };

  goToUserPage = event => {
    event.preventDefault();
    this.props.history.push(`/users/${this.props.list.user.username}`);
  };

  countdownCompleted = event => {};
}

export default ListUser;



// WEBPACK FOOTER //
// ./src/components/list/interface/list_user.jsx